<template>
  <gap-table>
    <template #previous>
      <gap-events
        type="previous"
        position="gaplist_bottom"
      />
    </template>
    <template #active>
      <gap-events
        type="active"
        position="gaplist_bottom"
      />
    </template>
    <template #next>
      <gap-events
        type="next"
        position="gaplist_bottom"
      />
    </template>
  </gap-table>
</template>

<script>
import gapEvents from './gapEvents.vue'
import gapTable from './gapTable.vue'

export default {
  name: 'CSpecialEvents',

  components: {
    gapEvents,
    gapTable
  }
}
</script>
